/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import styled from "@emotion/styled";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
  Typography,
  IconButton,
  Paper,
  Modal,
  Divider,
  AppBar,
  Toolbar,
  alertTitleClasses,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useRecoilValue } from "recoil";
import pr from "../lib/pr";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import io from "socket.io-client";
import moment from "moment";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import CloseIcon from "@mui/icons-material/Close";
import ReplaceAll from "../lib/ReplaceAll";
import queryString from "query-string";
import { loginState } from "../lib/State";
import { select } from "async";

// global css
const Container = styled.div``;
let sel = { mcd: "", device_id: "" };
let pos = 0; // 커서위치

function User() {
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const [num, setNum] = useState([-1, -1, -1, -1]);
  const [isFull, setIsFull] = useState(false);
  const [data, setData] = useState([]); // 회원
  const [band, setBand] = useState([]); // 밴드
  const [showMember, setShowMember] = useState(false);
  // const [showPop, setShowPop] = useState(false);  
  // const [showBand, setShowBand] = useState(false);

  // test
  // const config = {
  //   api: 'http://192.168.76.23:3001'
  // }  

  // production
  const config = {
    api: 'https://api.docircuit.org:3001'
  }

  const [showPop, setShowPop] = useState(false);
  const [showBand, setShowBand] = useState(false);
  const { ccid, kiosk_id } = queryString.parse(window.location.search);
  const [bands ,setBands] = useState([]);

  // 01. 키패드 번호
  const [kdata, setKdata] = useState({
    0: -1,
    1: -1,
    2: -1,
    3: -1
  });

  // 키오스크 로그인
  const kiosk_login = async () => {
    let result = await axios.post(config.api + "/hr/kiosk_login", {
      ccid: ccid,
      kiosk_id: kiosk_id,
    });
    if (result.data.success == 1) {
      setLoaded(true);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  useEffect(() => {
    kiosk_login();
  }, []);

  // 03. 초기화
  const onResetClick = () => {
    setKdata([-1, -1, -1, -1]);
    pos = 0;
  };

  // 풀스크린
  const toggle_full_screen = () => {
    setIsFull(!isFull);

    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };

  const onPopClose = () => {
    setShowPop(false);
    init_kdata();
    setShowMember(false);
    setShowBand(false);
  };

  const init_kdata = () => {
    pos = 0;
    setKdata({
      0: -1,
      1: -1,
      2: -1,
      3: -1
    })
  }

  // 05. 회원찾기
  const get_member = async () => {
    const phone = kdata[0] + kdata[1] + kdata[2] + kdata[3];
    let result = await axios.post(config.api + "/hr/user_all", {
      ccid: ccid,
      phone: phone,
    });
    if (result.data.success === 1) {
      setData(result.data.rows);
    }
    setTimeout(() => {
      setShowMember(true);
    }, 1000 / 2);
  };

  // 06. 센터별 밴드 가져오기  
  const get_center_band = async () => {
    let result = await axios.post(config.api + "/hr/get_center_band", {
      ccid: ccid,
    });
    if(result.data.success === 1) {
      setBands(result.data.rows);
    }
  };
  useEffect(()=>{
    get_center_band();
  },[]);
  

  // 02. 키패드 클릭
  const onKeypadClick = (e) => {

    if (pos === 4) {
      console.log('EOF');
      return;
    }

    const value = e.target.value;

    setKdata(state => {
      state[pos] = value;
      return { ...state };
    });

    // 커서이동
    pos++;
  };

  // 사용자 클릭
  const userClick = async (e) => {

    const mcd = e.target.value;
    sel.mcd = mcd;
    get_center_band();
    setShowMember(false);
    setShowBand(true);

    // 출석포인트
    let result = await axios.post(config.api + "/hr/class_confirm", {
      hr_mcd: mcd,
      ccid: ccid,
    });

    // 푸시알림
    if (result.data.success === 1 && result.data.count > 0) {
      result = await axios.post(config.api + '/push/to_mcd', {
        mcd: result.data.mcd,
        title: '출석',
        message: '출석 포인트가 적립되었습니다.',
        cid: result.data.cid,
      });
    }

  };

  // 밴드클릭
  const bandClick = async (serial) => {
    let result = await axios.post(config.api+"/hr/band_connect",{
      ccid : ccid,
      device_id : serial,
      mcd : sel.mcd
    });
    if(result.data.success === 1) {
      Swal.fire('알림', '연결되었습니다.');
      setShowPop(false);
      setShowBand(false);
      setShowMember(false);
      init_kdata();
    }
  }
  // const onDeviceClick = (e) => {
  //   sel.device_id = e.target.value;
  //   axios
  //     .post(configState.api + "/hr/band_connect", { ...sel, ccid: ccid })
  //     .then((result) => {
  //       setShowPop(false);
  //       setShowBand(false);
  //       setShowMember(false);
  //       // initNum();
  //       Swal.fire("연결되었습니다.");
  //     })
  //     .catch((e) => alert(e));
  // };

  // 04. 회원찾기 팝업
  useEffect(() => {
    if (pos === 4) {
      setTimeout(() => {
        setShowPop(true);
        get_member();
      }, 1000 / 2);
    }
  }, [pos]);

  return (
    <>
      {!loaded ? (
        <Loading />
      ) : (
        <>
          <Container>
            <Modal
              open={showPop}
              css={css`
                display: flex;
                justify-content: center;
                align-items: center;
              `}
            >
              <Paper
                css={css`
                  width: 550px;
                  min-height: 300px;
                `}
              >
                <AppBar sx={{ position: "static" }}>
                  <Toolbar>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography style={{ fontSize: 28 }}>회원찾기</Typography>
                    </Box>
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={onPopClose}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Toolbar>
                </AppBar>

                <div
                  css={css`
                    padding: 10px;
                  `}
                >
                  {showMember === true ? (
                    <>
                      {data.legnth > 0 ?
                        <Box>
                          <Typography sx={{ fontSize: 24 }}>
                            사용자를 선택하세요.
                          </Typography>                          
                        </Box> : null}

                      <Box sx={{ mt: 2 }}></Box>
                      {data.map((item, index) => {
                        let phone = item.phone;
                        phone = phone.slice(-4, phone.length);
                        let name = item.name;
                        let mcd = item.seq;
                        // name = name.slice(0, 2) + "*"; // +name.slice(-1,name.length);
                        return (
                          <Button
                            size="large"
                            variant="outlined"
                            key={index}
                            onClick={userClick}
                            value={mcd}
                            sx={{ mr: 0.5, pt: 1.3, pb: 1.3, pl: 3, pr: 3, fontSize: 24 }}
                          >
                            {name}
                          </Button>
                        );
                      })}

                      {data.length === 0 ? (
                        <div
                          css={css`
                            min-height: 30px;
                            font-size: 22px;
                          `}
                        >
                          검색된 회원이 없습니다.
                        </div>
                      ) : null}
                    </>
                  ) : null}

                  {showBand === true ? (
                    <>
                      <Box
                        sx={{ mt: 1 }}
                      >
                        {band.length > 0 ?
                          <Typography sx={{ fontSize: 24 }}>밴드를 선택하세요.</Typography> : null
                        }                        
                      </Box>
                      <div
                        css={css`
                          padding-top: 5px;
                        `}
                      ></div>                     

                      <Box>
                        <Box fontSize={26}>밴드를 선택하세요.</Box>
                        <Box marginTop={2} display="flex" flexWrap="wrap">
                          { bands.map((item, index)=> {
                            return <Box key={index} width="23%" marginRight={1} marginBottom={1}>                            
                            { item.can_use === 'Y' ?
                            <Button variant="contained" size="large" fullWidth={true} onClick={()=> bandClick(item.serial)}>
                              <Typography fontSize={25}>{item.band_no}</Typography>
                            </Button>: 
                            <Button variant="contained" size="large" fullWidth={true} disabled>
                              <Typography fontSize={25}>{item.band_no}</Typography>
                            </Button>                                                        
                            }
                          </Box>                     
                          }) }                          
                        </Box>
                        <Box marginTop={3} marginBottom={1}>
                          <Button variant="contained" fullWidth onClick={()=>get_center_band()}>
                            <Typography fontSize={22}>새로고침</Typography>
                          </Button>
                        </Box>

                      </Box>

                    </>
                  ) : null}
                 
                </div>
              </Paper>
            </Modal>

            <HelmetProvider>
              <Helmet>
                <link
                  rel="stylesheet"
                  type="text/css"
                  href="https://fonts.googleapis.com/css?family=Audiowide|Michroma|Orbitron|Russo+One"
                />
              </Helmet>
            </HelmetProvider>

            {loaded === false ? (
              <Loading />
            ) : (
              <Box
                css={css`
                  max-width: 500px;
                  margin: 0 auto;
                  margin-top: 50px;
                `}
              >
                <div
                  css={css`
                    text-align: center;
                  `}
                >
                  <img src="/img/logo.png" width="300" alt=""></img>
                  <Box sx={{ fontSize: "25px", mt: -2 }}>두써킷 HR</Box>
                </div>
                <div
                  css={css`
                    margin-top: 30px;
                  `}
                ></div>

                <Paper
                  css={css`
                    padding-top: 15px;
                    padding-bottom: 20px;
                    background: transparent;
                  `}
                >
                  <div
                    css={css`
                      text-align: center;
                      font-size: 26px;
                    `}
                  >
                    휴대폰 번호를 입력하세요. (뒤 4자리)
                  </div>

                  <div
                    css={css`
                      margin-top: 20px;
                      display: flex;
                      justify-content: center;
                      .input {
                        width: 80px;
                        text-align: center;
                        margin-right: 5px;
                      }
                    `}
                  >
                    <TextField
                      className="input"
                      disabled={true}
                      value={kdata[0] === -1 ? "" : kdata[0]}
                      InputProps={{
                        inputProps: {
                          style: {
                            fontSize: 30,
                            textAlign: "center",
                            fontWeight: "bold",
                          },
                        },
                      }}
                    ></TextField>
                    <TextField
                      className="input"
                      disabled={true}
                      value={kdata[1] === -1 ? "" : kdata[1]}
                      InputProps={{
                        inputProps: {
                          style: {
                            fontSize: 30,
                            textAlign: "center",
                            fontWeight: "bold",
                          },
                        },
                      }}
                    ></TextField>
                    <TextField
                      className="input"
                      disabled={true}
                      value={kdata[2] === -1 ? "" : kdata[2]}
                      InputProps={{
                        inputProps: {
                          style: {
                            fontSize: 30,
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "white",
                          },
                        },
                      }}
                    ></TextField>
                    <TextField
                      className="input"
                      disabled={true}
                      value={kdata[3] === -1 ? "" : kdata[3]}
                      InputProps={{
                        inputProps: {
                          style: {
                            fontSize: 30,
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "white",
                          },
                        },
                      }}
                    ></TextField>
                  </div>
                </Paper>

                <Paper
                  css={css`
                    padding-top: 5px;
                    margin-top: 15px;
                    padding-bottom: 10px;
                    background: transparent;
                  `}
                >
                  <div
                    css={css`
                      margin-top: 10px;
                      padding: 0 15px;
                      display: flex;
                      flex-wrap: wrap;
                      Button {
                        width: 30%;
                        margin: 5px;
                        height: 80px;
                        font-size: 26px;
                      }
                    `}
                  >
                    <Button
                      name="k1"
                      value="1"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      1
                    </Button>
                    <Button
                      name="k2"
                      value="2"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      2
                    </Button>
                    <Button
                      name="k3"
                      value="3"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      3
                    </Button>
                    <Button
                      name="k4"
                      value="4"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      4
                    </Button>
                    <Button
                      name="k5"
                      value="5"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      5
                    </Button>
                    <Button
                      name="k6"
                      value="6"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      6
                    </Button>
                    <Button
                      name="k7"
                      value="7"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      7
                    </Button>
                    <Button
                      name="k8"
                      value="8"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      8
                    </Button>
                    <Button
                      name="k9"
                      value="9"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      9
                    </Button>
                    <Button
                      name="k9"
                      value="0"
                      variant="contained"
                      onClick={onKeypadClick}
                    >
                      0
                    </Button>
                    <Button
                      name="k9"
                      variant="contained"
                      color="success"
                      onClick={onResetClick}
                    >
                      재설정
                    </Button>
                  </div>
                </Paper>

                <>
                  {!isFull ? (
                    <Box sx={{ mt: 3 }}
                    >
                      <Button
                        size="large"
                        variant="contained"
                        onClick={toggle_full_screen}
                        color="warning"
                        sx={{ fontSize: 25 }}
                      >
                        Full Screen
                      </Button>
                    </Box>
                  ) : null}
                </>
              </Box>
            )}
          </Container>
        </>
      )}
    </>
  );
}

export default User;
